import React, { Component } from 'react';
import { Layout, Page, Modal, TextContainer, Card, BlockStack, Text, Collapsible, List, Icon, Tooltip } from '@shopify/polaris';
import {
    // MobileChevronMajor, 
    QuestionMarkInverseMajor
  } from '@shopify/polaris-icons';
import { withRouter } from 'react-router-dom';
import 'react-circular-progressbar/dist/styles.css';
import '../index/index.css';
import SkeltonLoading from "../../../../components/SkeltonLoading";
import FreeDegradeWarningIcon from '../../../../assets/FreeDegradeWarningIcon';
import { reqGetUserPricingPlanList, reqUpdateUserPricingPlan, reqPlanConversion } from '../../../../api';
import { connect } from 'react-redux'
import { setPageData } from '../../../../redux/actions/getAppPageData';
import utils from '../../../../utils/utils';
import Language from '../../../../i18n/Language';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
const t = Language;

class Pricing extends Component {

    state = {
        loading: true,
        loadingPage: true,
        paidLoading: false,

        //优惠价格方案
        expired_time: '00:00:00',
        milli_second: '00',

        //useType为1 默认显示年费
        userType: 0,

        //用户信息
        userInfo: [],

        //价格方案列表
        pricingPlanList: [],

        //按钮点击触发
        onButtonType: 0,

        //点击改变背景颜色状态
        selectId: 0,

        //选中等级
        selectLevel: 0,

        //升降级弹窗
        modalData: {},
        openModalChange: false,
        openModalLoading: false,

        //优惠券数据
        showCouponData: false,

        //freePlanDegrade降级弹窗
        openFreePlanDegrade: false,
    }

    //进入页面调用接口
    componentDidMount() {
        // 判断是否已经缓存到redux中 如果缓存了则使用缓存的值
        let _page = this.props.page;
        if (Boolean(Object.keys(_page.pageInit?.pricing || {}).length)) {
            let res = _page.pageInit['pricing'].data
            let selectId = res.user_info.level <= 1 ? 6 : res.user_info.user_plan_id
            //这里添加一下优惠券数据
            let showCouponData = false
            if (res.coupon_data !== undefined) {
                showCouponData = res.coupon_data
            }
            this.setState({
                userInfo: res.user_info,
                pricingPlanList: res.pricing_plan_list,
                selectId: selectId,
                selectLevel: res.user_info.level + "",
                loading: false,
                loadingPage: false,
                showCouponData: showCouponData
            }, () => {
                if (res.user_info.remaining_time > 0 && res.user_info.remaining_time <= 30) {
                    //设置倒计时
                    let day_time = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000);
                    this.countdown(day_time)
                }
                if (selectId === 2 || selectId === 4) {
                    this.setState({
                        onButtonType: 0
                    })
                }
                if (selectId === 3 || selectId === 6) {
                    this.setState({
                        onButtonType: 2
                    })
                }
                if (selectId === 5 || selectId === 7) {
                    this.setState({
                        onButtonType: 1
                    })
                }
            })
        }
        this.getUserPricingPlanList();
    }

    componentWillUnmount = async () => {
        this.setState = () => false
    }

    getUserPricingPlanList = async () => {
        let params
        if (this.props.location.state && this.props.location.state.c_notice) {
            params = {
                c_notice: this.props.location.state.c_notice
            }
        }
        const response = await reqGetUserPricingPlanList(params);
        if (response.code === 200) {
            // 判断是否第一次 第一次则缓存
            this.props.getPageDataRedux(response);
            //如果用户是免费套餐则默认选中pro半年费
            let selectId = response.data.user_info.level <= 1 ? 6 : response.data.user_info.user_plan_id;

            //这里添加一下优惠券数据
            let showCouponData = false
            if (response.data.coupon_data !== undefined) {
                showCouponData = response.data.coupon_data
            }
            this.setState({
                userInfo: response.data.user_info,
                pricingPlanList: response.data.pricing_plan_list,
                selectId: selectId,
                selectLevel: response.data.user_info.level + "",
                loading: false,
                loadingPage: false,
                showCouponData: showCouponData
            }, () => {
                if (response.data.user_info.remaining_time > 0 && response.data.user_info.remaining_time <= 30) {
                    //设置倒计时
                    let day_time = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000);
                    this.countdown(day_time)
                }
                if (selectId === 2 || selectId === 4) {
                    this.setState({
                        onButtonType: 0
                    })
                }
                if (selectId === 3 || selectId === 6) {
                    this.setState({
                        onButtonType: 2
                    })
                }
                if (selectId === 5 || selectId === 7) {
                    this.setState({
                        onButtonType: 1
                    })
                }
            })
        } else {
            this.props.toggleToast(response.msg, true);
        }
    }

    //升级请求
    updateUserPricingPlan = async (id, discount_id = 0, isMonthModal = 0, level = 0) => {
        this.setState({
            paidLoading: true
        });
        const params = {
            ppid: id,
            discount_id: discount_id,
            is_month_change: isMonthModal,
            checked_level: level
        };

        const response = await reqUpdateUserPricingPlan(params);
        //这里弹窗升降级
        if (response.code === 20001) {
            this.setState({
                modalData: response.data,
                openModalChange: true,
                paidLoading: false,
                //关闭月费降免费弹窗
                openFreePlanDegrade: false,
            });
            return null;
        }
        if (response.code === 200) {
            this.props.toggleToast(response.msg, false);
            //重新加载数据
            // this.getUserPricingPlanList();
            //跳转支付页面
            let j_url = response.data.confirmation_url;
            if (j_url) {
                window.top.location.href = j_url;
            }

            return null;
        }

        this.setState({
            paidLoading: false,
            openModalChange: false,
            openModalLoading: false,
            //关闭月费降免费弹窗
            openFreePlanDegrade: false,
        });
        this.props.toggleToast(response.msg, true);

        return null;
    }

    //确认转换升级
    updatePlanConversion = async (id, pay_type) => {
        this.setState({
            paidLoading: true,
            openModalLoading: true,
        });
        // 一次性付费
        if (pay_type === 1) {
            const response = await reqPlanConversion({ ppid: id });
            if (response.code === 200) {
                this.setState({
                    paidLoading: false,
                    openModalChange: false,
                    onButtonType: 0,
                });
                this.props.toggleToast(response.msg, false);
                //重新加载数据
                this.getUserPricingPlanList();
            } else {
                this.setState({
                    paidLoading: false,
                    openModalLoading: false
                });
                this.props.toggleToast(response.msg, true);
            }
        }
        // 订阅付费
        if (pay_type === 2) {
            this.updateUserPricingPlan(id, 0, 1);
        }

        return null;
    }

    // 时分秒倒计时
    countdown = async (end_time) => {
        var cacheTimer = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            if (date3 < 1000) {
                clearInterval(cacheTimer);
            } else {
                //计算出小时数
                let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(leave1 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";

                if (hours < 10) {
                    exp_time += "0" + hours + ":"
                } else {
                    exp_time += hours + ":"
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":"
                } else {
                    exp_time += minutes + ":"
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds
                } else if (seconds === 60) {
                    exp_time += "00"
                } else {
                    exp_time += seconds
                }
                this.setState({ expired_time: exp_time })
            }
        }, 1000)
        // 毫秒倒计时
        setTimeout(() => {
            setInterval(() => {
                let date1 = new Date(); //开始时间
                let date2 = end_time * 1000; //开始时间
                let date3 = date2 - date1 //时间差的毫秒数
                if (date3 < 0) {
                    this.setState({ milli_second: "00" })
                } else {
                    //计算相差毫秒数
                    let milli = date3 % (100)

                    let exp_time = "";

                    if (milli < 10) {
                        exp_time += "0" + milli
                    } else {
                        exp_time += milli
                    }
                    this.setState({ milli_second: exp_time })
                }
            }, 80)
        }, 1000)
    }

    // 选中改变数据
    changeCardByData = (data, level) => {
        this.setState({
            selectId: data.id,
            onButtonType: data.button_type,
            selectLevel: level
        })
    }

    //如果是月费降级到免费 打开FreePlanDegrade弹窗
    handleFreePlanDegrade = () => {
        this.setState({
            openFreePlanDegrade: true,
        })
    }

    render() {
        const {
            state: { expired_time, milli_second, userInfo, pricingPlanList, selectId, openFreePlanDegrade },
            changeCardByData,
        } = this;

        //定义服务开关
        const displayAllowImg = <td className="td__Padding"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAARVBMVEUAAABDvABm5ABEuwBEvQBEvABUwwBEvABIvgBDvABEvABEuwBDvABEvgBFvgBGxQBDvABFvABDvABEvQBFvQBEuwBDuwBqJBhYAAAAFnRSTlMA8wOlf6oKvyPo2dNyUjkWp4Kug0LHsgVnHwAAAO9JREFUOMuN1eGOgyAQBOBZsYKCpVx7+/6Pel7SdF3Lhp1fmnxkiJEFOqmEuBFtMZQEM7VlPiW32mXLTHwJzcu321fuZN2vbmYjs669sZnbuV5cT1q9dvvOg+zvDa4juC6qeFReaQypAniykcePPDcA2XLTJDIDyXTASSYU4ytPOODj814QXI4DostxxMaSX7Icb6DTquVO4vSe6IDigEOK01CqX8C/FKeroyy640jqOo4IfJFdxwGFlTQcFyRW0nCcgKxl32UAjZV89Rw3/4/rPwr+w+U/ruMB4B8p/iHlH3vjQeoezb3U53jYj6+PP8nTYApgP0coAAAAAElFTkSuQmCC" alt="SEOAnt" /></td>;
        const displayText = <td>-</td>;

        //特殊表示icon
        const thumbsUpIcon = <div style={{ marginLeft: "1rem" }}><svg t="1656655521240" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1470" width="16" height="16"><path d="M194.792475 478.69343c16.167215 0 29.330002-13.163811 29.330002-29.346375 0-16.092513-13.015432-29.212322-29.801746-29.212322-0.086981 0-0.177032 0-0.264013 0l-60.606333 0.177032c-1.560542-0.206708-3.149736-0.325411-4.76963-0.325411-21.291932 0-38.636972 17.537422-38.636972 39.09439l-0.323365 423.853427c0 21.645996 16.9613 38.578644 38.636972 38.578644l1.677199 0.057305c0.707105 0.029676 1.385557 0.059352 2.032286 0.059352 0.823761 0 1.64957-0.029676 1.826602-0.11768l59.926858 0.086981c0.559748 0 1.001817-0.11768 1.089821-0.11768 0 0-0.029676 0-0.116657 0.057305l3.76986-0.147356 0-0.382717c13.517875-2.236947 23.64656-13.84124 23.64656-27.799136 0-13.987572-10.129708-25.589818-23.64656-27.828812l0-0.766456-49.827849 0 1.413186-385.92356L194.792475 478.69036z" p-id="1471" fill="#f51212"></path><path d="M918.228001 436.301947c-18.199501-29.66974-45.204551-44.821835-82.22163-46.322002-1.883907-0.25071-3.799536-0.412392-5.77247-0.412392l-195.744149-0.648776c13.398148-40.359196 20.732184-83.750449 20.732184-122.740462 0-27.255761-3.00545-54.686507-8.894577-81.543178l-1.206478-3.196809-0.089028 0.01535c-12.161994-46.837748-53.477982-79.259158-101.626585-79.259158-55.393611 0-97.18032 46.248324-97.18032 107.576087l-0.059352 3.047406c-0.057305 2.222621-0.116657 4.40124 0.059352 6.16849-2.796696 101.715613-83.869153 187.397041-188.559517 199.324698l-3.358491 0.36839-0.76441 274.43128 0 228.491994 13.930267 0.005117 0.587378 0.11154 3.179412-0.027629 0.01535-0.081864 485.653959 0.198521 8.685823-0.236384c19.84907 0 31.038924-5.03569 48.621371-16.344247 16.22452-10.482749 29.359678-25.266453 37.751812-42.316781 2.562359-3.76986 4.418636-7.862062 5.565762-12.251022l75.30101-336.657506c1.089821-4.225231 1.472538-8.643867 1.149173-12.56006C935.660023 478.42737 930.212964 455.900308 918.228001 436.301947zM879.148961 488.807788l-0.912789 3.799536 0.295735 0.074701-80.129992 355.2387-0.148379 0.353041c-2.296299 5.536087-6.15314 10.160407-11.101849 13.340843-3.415796 2.209318-7.185656 3.622504-11.161201 4.239558-0.470721-0.057305-0.941442-0.057305-1.413186-0.057305l-3.03308 0.086981-462.84344-0.530073-0.177032-392.299781c79.540567-35.986609 148.155295-73.959455 183.080735-167.79868l0.295735 0.074701 1.119497-3.328815c3.709485-11.263531 6.596232-22.350031 8.598842-32.909527 5.447059-28.577872 5.212722-56.422034 5.183046-58.041928-1.766226-13.502525 1.206478-24.738427 8.80555-33.394574 8.598842-9.777691 21.673625-14.151301 30.744211-14.151301 22.586414 0.766456 45.526893 30.966269 45.61592 48.163953 0.029676 0.26606 5.38873 26.945699 5.418406 55.186903 0.057305 27.65178-2.651386 45.277206-3.858888 51.828412l-0.500397 0-0.589424 3.062755c-5.595438 29.522384-15.518438 57.794287-29.41903 84.003206l-0.972141 2.856048 0.118704 0.132006c-1.885953 4.696975-2.856048 9.643638-2.856048 14.709003 0 25.032116 27.121707 25.032116 41.697681 25.032116l233.381351 0.264013 7.15598 0.221034c1.266853 0.045025 2.503007 0.089028 3.592828 0.118704l0 0.425695 5.538133-0.248663c10.453073 0 19.937075 5.344728 25.412786 14.296611C880.709503 471.080032 881.829 480.283648 879.148961 488.807788z" p-id="1472" fill="#f51212"></path></svg></div>;

        //处理价格方案内容
        const pricingPlanContent = (pricing_plan, level) => {
            let content = pricing_plan.map((item, index) => {
                //计算时间
                //向上取整
                let month = Math.floor(item.valid_time / 3600 / 24 / 30);
                //保留两位小数，不四舍五入
                let count_price = Math.floor(item.price / month * 100) / 100;

                return <div className={(selectId === item.id ? 'pricingPlanContentBox active' : 'pricingPlanContentBox')} key={index} onClick={() => changeCardByData(item, level)}>
                    <div className='pricingPlanContentItem'>
                        <div className='pricingPlanContentPrice'>
                            {t("$")}{item.price}
                            {item.pay_type === 1 ? <i className='pricingPlanContentCount'>≈ {count_price} * {month}</i> : null}
                        </div>
                        <i className='pricingPlanContentName'>{item.name}</i>
                        <span className='pricingPlanContentHand'>{(month === 6 ? thumbsUpIcon : null)}</span>
                    </div>
                </div>;
            })

            return <div className='pricingPlan'>
                <div className='pricingPlanContent'>
                    {content}
                </div>
                <div className='pricingPlanContentButton' style={{ height: '4rem' }}>
                    {/* {button_box} */}
                </div>
            </div>
        }

        //免费版本内容特殊处理
        const pricingPlanContentByFree = (pricing_plan) => {
            return <div>
                <div style={{ textAlign: 'center', height: pricing_plan[0].button_type === 3 ? '16.8rem' : '16.8rem', display: 'grid', placeItems: 'center' }}>
                    {userInfo.level === 1 ? <span style={{ fontSize: "2.6rem", textAlign: "center", color: "#5B5B5B" }}>$0.00</span> : <span style={{ fontSize: "2.6rem", textAlign: "center", color: "#C4C4C4" }}>$0.00</span>}
                </div>
            </div>
        }

        //修改图片数量
        const autoImgOmpressNum = (level, num) => {
            if (num === 0) {
                return null;
            }
            if (level === 1) {
                return num + ' images';
            } else {
                return num + ' images/month';
            }
        }
        // 循环输出价格方案
        const pagePricingPlan = this.state.loading && pricingPlanList.length === 0 ? <div></div> :
            Object.keys(pricingPlanList).map((level, index) => {
                let services = pricingPlanList[level].services;
                let pricingPlan = pricingPlanList[level];

                return <div key={index} className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
                    <Card>
                        <div className="Polaris-Card__Section">
                            <h2 className="Polaris-Heading" style={{ textAlign: "center", fontWeight: 'bold' }}  >
                                {pricingPlan.level_name} {t("Plan")}
                            </h2>
                            {pricingPlan.id === 1 ? pricingPlanContentByFree(pricingPlan.pricing_plan) : pricingPlanContent(pricingPlan.pricing_plan, level)}

                            <div className="pricingList pro">
                                <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center' }}>
                                    <thead></thead>
                                    <tbody>
                                        <tr><td>{pricingPlan.pageseo_num === 0 ? 'Unlimited' : pricingPlan.pageseo_num}&nbsp;{t("products")}</td></tr>
                                        <tr><td>{autoImgOmpressNum(pricingPlan.id, pricingPlan.auto_img_ompress_num)}</td></tr>
                                        <tr>{services.AutoScanBrokenlinks ? displayAllowImg : displayText}</tr>
                                        <tr>{services.SEOChecker ? displayAllowImg : displayText}</tr>
                                        <tr>{services.KeywordSuggestionTool ? displayAllowImg : displayText}</tr>
                                        <tr>{services.UnlimitedBlogSEOScan ? displayAllowImg : displayText}</tr>
                                        <tr>{services.BulkEditImagealttextByProduct ? displayAllowImg : displayText}</tr>
                                        <tr>{services.BulkEditImagealttextByOthers ? displayAllowImg : displayText}</tr>
                                        <tr>{services.JSONLDStructuredDataSetup ? displayAllowImg : displayText}</tr>
                                        <tr>{services.BrokenLinkImportExport ? displayAllowImg : displayText}</tr>
                                        <tr>{services.BrokenLinkRepair ? displayAllowImg : displayText}</tr>
                                        <tr>{services.GoogleSearchConsole ? displayAllowImg : displayText}</tr>
                                        <tr>{services.BulkEditMetaTags ? displayAllowImg : displayText}</tr>
                                        <tr>{services.AutomaticBrokenlinksrepairs ? displayAllowImg : displayText}</tr>
                                        <tr>{services.DailyBrokenlinkMissingpageReports ? displayAllowImg : displayText}</tr>
                                        <tr>{services.IndexNoIndexMetaRobotsSetting ? displayAllowImg : displayText}</tr>
                                        <tr>{services.DofollowNofollowMetaRobotsSettings ? displayAllowImg : displayText}</tr>
                                        <tr>{services.AMP ? displayAllowImg : displayText}</tr>
                                        <tr>{services.CompetitorKeywords ? displayAllowImg : displayText}</tr>
                                        <tr>{pricingPlan.keywords_month_num === 0 ? displayText : <td>{pricingPlan.keywords_month_num} {t("websites/month")}</td>}</tr>
                                        <tr>{pricingPlan.keywords_num === 0 ? displayText : <td>{pricingPlan.keywords_num} {t("keywords")}</td>}</tr>
                                        <tr><td>{pricingPlan.support}</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Card>
                </div>
            })

        //会员当前方案
        const userNowLevelPlan = (userInfo) => {
            let remaining_time = userInfo.remaining_time;
            if (userInfo.level === 1) {
                return <div>
                    <div>{t("Remaining Time")}</div>
                    <div style={{ color: "#F51212", fontSize: '16px' }}>{t("Unlimited")}</div>
                </div>
            }
            if (remaining_time === 0) {
                return <div>
                    <span>{t("Subscription")}</span>
                </div>
            }
            if (remaining_time > 0 && remaining_time <= 30) {
                return <div>
                    <div>{t("Remaining Time")}</div>
                    <div style={{ color: "#F51212", fontSize: '16px' }}>{userInfo.remaining_time - 1} {t("days")} {expired_time} {milli_second}</div>
                </div>
            } else {
                return <div>
                    <div>{t("Remaining Time")}</div>
                    <div style={{ color: "#F51212", fontSize: '16px' }}>{userInfo.remaining_time} {t("days")}</div>
                </div>
            }
        }

        const pageContent = this.state.loadingPage ? null : (
            <div>
                <div className="pricingContent">
                    <div className="Polaris-Layout">
                        <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird">
                            <Card>
                                <div className="Polaris-Card__Section">
                                    <section className="PricingFirst">
                                        <div className='PricingFirstCurrentPlan'>
                                            <div>
                                                <div>{t("Current Plan")}</div>
                                                <div style={{ color: "#008060", fontSize: '16px' }}>{userInfo.level_name} {t("Plan")}
                                                    {userInfo.level_name !== "Free" ? "(" + userInfo.plan_name + ")" : ""}</div>
                                            </div>
                                        </div>
                                        <div className='PricingFirstRemaining'>
                                            {userNowLevelPlan(userInfo)}
                                        </div>
                                    </section>
                                    <div className="pricingList">
                                        <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr><td><div>{t("On page SEO Scan")}&emsp;</div></td></tr>
                                                <tr><td><div>{t("Image Compress & Auto")}</div></td></tr>
                                                <tr><td><div>{t("Auto Scan Broken links")}</div></td></tr>
                                                <tr><td><div>{t("SEO Checker")}</div></td></tr>
                                                <tr><td><div>{t("Keyword Suggestion Tool")}</div></td></tr>
                                                <tr><td><div>{t("Unlimited Blog SEO Scan")}</div></td></tr>
                                                <tr><td><div>{t("Bulk Edit Image alt text(Product)")}&emsp;</div></td></tr>
                                                <tr><td><div>{t("Bulk Edit Image alt text(Others)")}&emsp;</div></td></tr>
                                                <tr><td><div>{t("JSON-LD Structured Data Setup")}</div></td></tr>
                                                <tr><td><div>{t("Bulk import and export broken link")}</div></td></tr>
                                                <tr><td><div>{t("Broken Link Repair")}</div></td></tr>
                                                <tr><td><div>{t("Google Analytics")}</div></td></tr>
                                                <tr><td><div>{t("Bulk Edit Meta Tags")}</div></td></tr>
                                                <tr><td><div>{t("Automatic Broken links repairs")}&emsp;</div></td></tr>
                                                <tr><td><div>{t("Daily Broken link & Missing page Reports")}&emsp;</div></td></tr>
                                                <tr><td><div>{t("Index/No Index Meta Robots Setting")}</div></td></tr>
                                                <tr><td><div>{t("Dofollow/Nofollow -Meta Robots Settings")}</div></td></tr>
                                                <tr><td><div>{t("AMP")}</div></td></tr>
                                                <tr><td><div>{t("Competitor keywords")}</div></td></tr>
                                                <tr><td><div>{t("Competitor keywords - competitor website")}</div></td></tr>
                                                <tr><td><div>{t("Keywords library - my keyword")}</div></td></tr>
                                                <tr><td><div>{t("SUPPORT")}</div></td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        {/* 这里需要遍历输出价格套餐 */}
                        {pagePricingPlan}
                    </div>
                </div>
            </div>
        );

        //这里有四个弹窗
        const upgradeModalTextByDisposable = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used {{v1}} for {{v2}} days, it still has $ {{v3}} left.", this.state.modalData.now_plan, this.state.modalData.after_days, this.state.modalData.balance)}
                <br /> <br />
                {t("Now you want to upgrade to Premium Plan, we will change this $")}{this.state.modalData.balance} {t("to premium plan(half year), at the price of the premium plan(half year), you will be able to use the premium plan(half year) for")} {this.state.modalData.change_days} {t("days.")}
                <br /> <br />
                {t("Are you sure to change ?")}
                <br /> <br />
                <span style={{ color: "red" }}>{t("Notice:This process is irreversible!")}</span>
            </p>
        )

        const degradeModalTextByDisposable = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used {{v1}} for {{v2}} days, it still has $ {{v3}} left.", this.state.modalData.now_plan, this.state.modalData.after_days, this.state.modalData.balance)}
                <br /> <br />
                {t("Now you want to degrade to Pro Plan, we will change this $")}{this.state.modalData.balance} {t("to Pro Plan(half year), at the price of the Pro Plan(half year), you will be able to use the Pro Plan(half year) for")} {this.state.modalData.change_days} {t("days.")}
                <br /> <br />
                {t("Are you sure to change ?")}
                <br /> <br />
                <span style={{ color: "red" }}>{t("Notice:This process is irreversible!")}</span>
            </p>
        )

        const upgradeModalTextBySubscription = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used Pro Plan(per month) for")}&nbsp;{this.state.modalData.charge_days} {t("days, If you switch to the premium plan(per month), the old recurring bill will be closed and charged for")} {this.state.modalData.charge_days} {t("days, then the new recurring bill will start charging.")}
                <br /><br />
                {t("Are you sure to change ?")}
            </p>
        )
        const degradeModalTextBySubscription = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used premium plan(per month) for")}&nbsp;{this.state.modalData.charge_days} {t("days, If you switch to the Pro Plan(per month), the old recurring bill will be closed and charged for")} {this.state.modalData.charge_days} {t("days, then the new recurring bill will start charging.")}
                <br /><br />
                {t("Are you sure to change ?")}
            </p>
        )

        //首字母大写
        const pageModalTitle = (str) => {

            return str.replace(str[0], str[0].toUpperCase());;
        }

        //升降级弹窗
        const pageModal = this.state.modalData.length === 0 ? null : (
            <div>
                <Modal
                    open={this.state.openModalChange}
                    onClose={() => { this.setState({ openModalChange: !this.state.openModalChange }) }}
                    title={this.state.modalData.change_type !== undefined ? pageModalTitle(this.state.modalData.change_type) : null}
                    primaryAction={{
                        content: t("YES"),
                        onAction: () => { this.updatePlanConversion(selectId, this.state.modalData.pay_type) },
                        loading: this.state.openModalLoading
                    }}
                    secondaryActions={[
                        {
                            content: t("NO"),
                            onAction: () => { this.setState({ openModalChange: !this.state.openModalChange }) },
                        },
                    ]}
                >
                    <Modal.Section>
                        <TextContainer>
                            {this.state.modalData.pay_type === 1 ? this.state.modalData.change_type === 'upgrade' ? upgradeModalTextByDisposable : degradeModalTextByDisposable : null}
                            {this.state.modalData.pay_type === 2 ? this.state.modalData.change_type === 'upgrade' ? upgradeModalTextBySubscription : degradeModalTextBySubscription : null}
                        </TextContainer>
                    </Modal.Section>
                </Modal>
            </div>)

        //月费降级到免费弹窗
        const freePlanDegrade = (
            <Modal
                open={openFreePlanDegrade}
                title={t("Degrade warning")}
                onClose={() => { this.setState({ openFreePlanDegrade: !this.state.openFreePlanDegrade }) }}
                secondaryActions={{
                    content: t("Let me think"),
                    onAction: () => { this.setState({ openFreePlanDegrade: !this.state.openFreePlanDegrade }) }
                }}
                primaryAction={[
                    {
                        content: t("Continue degrade"),
                        onAction: () => { this.updateUserPricingPlan(1) },
                        loading: this.state.paidLoading
                    },
                ]}
            >
                <Modal.Section>
                    <div className='freePlanDegradeContent'>
                        <Icon source={FreeDegradeWarningIcon} />
                        <p>{t("If you degrade to the free plan now, the features included in the existing paid plan will not be available, are you sure you want to degrade?")}</p>
                    </div>
                </Modal.Section>
            </Modal>
        )

        const pageContentQA = this.state.loadingPage ? null : (
            <div style={{ marginTop: "1rem" }}>
                <Card>
                    <div onClick={this.faqControl} className="FAQ-Content" aria-controls="basic-collapsible">
                        <BlockStack>
                            <Text variant="headingMd" as="h2">{t("Frequently Asked Questions")}</Text>
                        </BlockStack>
                    </div>
                    
                    <Collapsible open={true} id="basic-collapsible">
                        <section className="FAQ-Box">
                            <List type="number">
                                <List.Item>{t("What does a paid plan do for me?")}</List.Item>
                                <div className="FAQ_Answer">
                                    <p>{t("With minimal investment of time and money, improve the unpaid ranking of your store on the Google search results page, bring more organic traffic and conversions. According to statistics: on average SEOAnt customers save 218 hours of manual work on SEO.")}</p>
                                </div>

                                <List.Item>{t("If I don't want to use the app after paying, will I get a refund?")}</List.Item>
                                <div className="FAQ_Answer">
                                    <p>{t("Please contact our customer service to apply for a refund. We will give you a refund within 7 working days. In principle, We will give you a refund based on the remaining days of your package.")}</p>
                                    <p>{t("By the way, please tell us the reason for your dissatisfaction, Because your feedback will make us better.")}</p>
                                    <p>{t("Shopify billing rules:")}</p>
                                    <p style={{ marginLeft: "1rem" }}>{t("Per month package(subscription--Recurring Pricing plans):")}</p>
                                    <p style={{ marginLeft: "1rem" }}> <a href="https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#subscriptions" rel="noreferrer" target="_blank">https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#subscriptions</a></p>
                                    <p style={{ marginLeft: "1rem" }}>{t("Half year package and One year package(One-time app charges):")}</p>
                                    <p style={{ marginLeft: "1rem" }}><a href="https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#one-time-app-charges" rel="noreferrer" target="_blank">https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#one-time-app-charges</a></p>
                                    <p>{t("Shopify refund rules:")}</p>
                                    <p style={{ marginLeft: "1rem" }}><a href="https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#request-an-app-refund-or-credit" rel="noreferrer" target="_blank" >https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#request-an-app-refund-or-credit</a></p>
                                </div>

                                <List.Item>{t("What should I do if I want to terminate a paid plan?")}</List.Item>
                                <div className="FAQ_Answer">
                                    <p>{t("Per month package(subscription--Recurring Pricing plans):")}</p>
                                    <p style={{ marginLeft: "1rem" }}>{t("a. Click the degrade button under Free Plan on the pricing page to turn off the billing.")}</p>
                                    <p style={{ marginLeft: "1rem" }}>{t("b. Go to shopify to close the subscription order.")}</p>
                                    <p>{t("Half year package and One year package(One-time app charges):")}</p>
                                    <p style={{ marginLeft: "1rem" }}>{t("Go to shopify to close the subscription order and contact customer service (click the floating button in the lower right corner).")}</p>
                                </div>

                                <List.Item>{t("Why do I have to pay for the Per month package again after uninstalling the app and then installing it back?")}</List.Item>
                                <div className="FAQ_Answer">
                                    <p>{t("Per month package is a recurring billing plan in the subscription, Shopify will generate an order when you purchase, and the billing cycle for this order is 30 days, but if you uninstall our app after paying, Shopify will automatically close the order, so you need to pay again to regenerate the order and start billing again. Note: you need to contact customer service to refund the previous order.")}</p>
                                </div>
                            </List>
                        </section>
                    </Collapsible>
                </Card>
            </div>
        )

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终内容
        var pageContentLast = this.state.loadingPage ? <SkeltonLoading /> :
            <Page
                title={<div style={{ display: "flex", alignItems: "center"}}>
                {t("Pricing")}&nbsp;
                <Tooltip content={t("Explore the plans available below and select one that works best for you.")}>
                    {<Icon backdrop source={QuestionMarkInverseMajor} />}
                    </Tooltip>
                </div>}
                backAction={{
                    content: 'back',
                    onAction: () => {
                        utils.routeJump(this, "/plan")
                    }
                }}
            >
                <title>SEOAnt - Pricing</title>
                <Layout>
                    <Layout.Section>
                        {pageContent}
                        {pageContentQA}
                    </Layout.Section>
                </Layout>
                {/* 升降级弹窗 */}
                {pageModal}

                {/* 降级弹窗 */}
                {freePlanDegrade}

                {/* 底部 */}
                {FooterHelpBox}
            </Page>

        return (
            <div className='Pricing'>
                {pageContentLast}
            </div>
        );
    }

}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['pricing', data]));
    },
})

Pricing = connect(
    mapStateToProps,
    mapDispatchToProps
)(Pricing);

export default withRouter(Pricing);